
eval("define(\'text!htmlContent/contributors-list.html\',[],function () { return \'{{#.}}<a href=\"{{html_url}}\" title=\"{{login}} - {{html_url}}\"><img src=\"{{avatar_url}}?size=30\" alt=\"{{login}}\" width=\"30\" height=\"30\" /></a>{{/.}}\\n\';});\n\n//# sourceURL=/text!htmlContent/contributors-list.html");

